import { useTranslation } from 'react-i18next'
import { Link, useLocalPathname } from '../i18n/Link'
import { InnerTrail } from './Interior'

const groups: [string, string][][] = [
  [
    ['features', '/features'],
    ['compare', '/compare'],
    ['pricing', '/pricing'],
    ['enterprise', '/enterprise'],
    ['security', '/security'],
    ['download', '/download'],
  ],
  [
    ['help', '/help'],
    ['docs', '/docs'],
    ['blog', '/blog'],
    ['community', '/community'],
    ['changelog', '/changelog'],
    ['status', '/status'],
  ],
  [
    ['about', '/about'],
    ['contact', '/contact'],
    ['careers', '/careers'],
    ['press', '/press'],
    ['partners', '/partners'],
  ],
  [
    ['privacy', '/privacy'],
    ['terms', '/terms'],
    ['cookies', '/cookies'],
  ],
]

export default function InteriorNavigation() {
  const { t } = useTranslation('common')
  const pathname = useLocalPathname()
  const links = groups.find((group) => group.some(([, path]) => path === pathname)) || groups[0]
  const current = links.find(([, path]) => path === pathname)?.[0]
  const name = current ? t(`pages.${current}`) : t('pages.notFound')
  return (
    <div className="interior-navigation">
      <InnerTrail name={name} />
      <nav aria-label={t('interior.related')} className="chapter-navigation">
        {links.map(([key, path]) => (
          <Link key={path} to={path} aria-current={pathname === path ? 'page' : undefined}>
            {t(`pages.${key}`)}
          </Link>
        ))}
      </nav>
    </div>
  )
}
